export default __webpack_public_path__ + "static/media/Rectangle.f2535ba5.png";